import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './Stroke1Icon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const Stroke1Icon = React.forwardRef<SVGSVGElement, SvgIconProps>(function Stroke1Icon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 16 10" component={Icon} {...props} />
  );
});
